import { render, staticRenderFns } from "./LegalNoticeLayer.vue?vue&type=template&id=f054974c&scoped=true"
import script from "./LegalNoticeLayer.vue?vue&type=script&lang=js"
export * from "./LegalNoticeLayer.vue?vue&type=script&lang=js"
import style0 from "./LegalNoticeLayer.vue?vue&type=style&index=0&id=f054974c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f054974c",
  null
  
)

export default component.exports